import { MenuItemType, SingleItemDropdownInterface } from '../types/menu-interface'
import { isFlatMenuItem } from './is-flat-menu-item'

export const checkNestedIsActive = (item: SingleItemDropdownInterface): boolean => {
  return item.dropdownItems.some(item =>
    isFlatMenuItem(item) ? item.isActive(item.href) : checkNestedIsActive(item),
  )
}
